// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "09aca44663fd5b3ba771bac948788ee2" + ".css";
};